var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('add-new-site',{attrs:{"default-message":"Let's add your new site... Only 2 steps!"}})}
var staticRenderFns = []

export { render, staticRenderFns }